import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import axios from "axios";
import { HeadersUtil } from "app/utils/headersUtil";
import Api from "app/services/common/Api";
import {Simulation} from "../../model/cp/emsnQnt";

export interface SearchModel {
  searchType: string;
  fromDt: string;
  cmplxClCd?: string;
}

export class EmissionService extends Api {
  private static service: EmissionService;
  static readonly deleteRow: any;

  public static getInstance(): EmissionService {
    if (!EmissionService.service) {
      EmissionService.service = new EmissionService();
    }
    return EmissionService.service;
  }

  private static GET_EMSN_TREND_CHART_URL: string =
    process.env["REACT_APP_URL_CP"] + "/pssnEmcrdPrcnd/emsnQntStatus";

  public async getEmission() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/emcrd"
    );
    return await super.get<any>(url);
  }

  public getEmission2() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/emcrd"
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public getEmissionLatestByItmGrpNm(itmGrpNm: string) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/emcrd/latest",
      { itmGrpNm: itmGrpNm }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public getEmissionOverseaLatestByItmGrpNm(itmGrpNm: string) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/emcrd/oversea/latest",
      { sortColumn: "itmNm", sortAscending: 1 }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  //배출권 고유번호 검색
  public getEmissionByIsinCd(isinCd: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/emcrd",
      { isinCd: isinCd }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public getEmissionOverseaByIsinCd(isinCd: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/emcrd/oversea",
      { isinCd: isinCd }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public getEmissionCecicc() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CO + "/cecicc"
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  //배출권 현황 (년도별 스코프 정보 검색)
  public getEmissiopnStatus(year: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/StatusSelect/" + year
    );
    return super.get(url);
  }

  public getEmissionFacilityStatus(year: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/FacilitySelect/" + year
    );
    return super.get(url);
  }

  public getBoardScope() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + `/EmissionsStatus/getBoardScope/`
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public async getGoalEmissions() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/roadMap/goalEmissions"
    );
    return await super.get<any>(url);
  }

  public async getScope(scope: string, startYear: string, endYear: string) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP +
        "/multiEmissionSource/" +
        scope +
        "/" +
        startYear +
        "/" +
        endYear
    );
    return await super.get(url);
  }

  public getYearEmissiopnStatus() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/yearSelect"
    );
    return super.get(url);
  }

  public getPssnEmcrdPrcnd() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/pssnEmcrdPrcnd?perPage=10&page=1"
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public getStaHolEmis2() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/pssnEmcrdPrcnd/staHolEmis"
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public getEmissionsComplex(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/emissionscomplex"
    );
    return super.get<any>(url, search);
  }
  public getEmissionsComplexGrid(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP +
        "/EmissionsStatus/admin/emissionscomplex/grid"
    );
    return super.get<any>(url, search);
  }

  public getEmissionsTrand(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/erstatistics"
    );
    return super.get<any>(url, search);
  }
  public getEmissionsTrandGrid(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/erstatistics/grid"
    );
    return super.get<any>(url, search);
  }
  public getEmissionsFacilityTrand(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/emissionsfacility"
    );
    return super.get<any>(url, search);
  }
  public getEmissionsFacilityTrandGrid(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP +
        "/EmissionsStatus/admin/emissionsfacility/grid"
    );
    return super.get<any>(url, search);
  }
  public getComplexBusinessEmissions(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP +
        "/EmissionsStatus/admin/complexBusinessEmissions"
    );
    return super.get<any>(url, search);
  }

  public async getEmsnTrendChartData() {
    return await super.get<Simulation>(EmissionService.GET_EMSN_TREND_CHART_URL);
  }

  public getGasEmistatus(search: SearchModel) {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP +
        "/EmissionsStatus/admin/gasEmistatus"
    );
    return super.get<any>(url, search);
  }


}
